import { render, staticRenderFns } from "./Freespins.vue?vue&type=template&id=6566aaa2&"
import script from "./Freespins.vue?vue&type=script&lang=js&"
export * from "./Freespins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports